import { CategoriasEstados } from '@cf-v5-workspace/enums';
import CrmEstadosModel from './crm-estados.model';

export default class LogsEstadosModel {

	public id: number;
	public categoria: CategoriasEstados;
	public idOrigen: number;
	public idEstado: number;
	public idEstadoAnterior: number;
	public idMotivo: number;
	public observacionEstado: string;
	public fecha: Date;
	public usuario: string;
	public tipoDocumento: string;
	public prefijoDocumento: string;
	public fechaCreacion: Date;
	public fechaModificacion: Date;
	public usuarioCreacion: string;
	public usuarioModificacion: string;
	public firmaDigitalCodigoCorreo: string;
	public firmaDigitalCodigoSMS: string;
	public tipoDocumentoSoporte: string;
	public prefijoDocumentoSoporte: string;
	public consecutivoDocumentoSoporte: number;
	public enviarCorreo: boolean;
	public agregarAlerta: boolean;
	public enviarSMSCliente: boolean;
	public enlaceSolicitudes: string;
	public rutaDocumentoSoportePDF: string;
	public descripcionOrigen: string;
	public explicacion: string;
	public objEstados: CrmEstadosModel = new CrmEstadosModel();


	//nuevos parametroas usados en historias clinicas
	public descripcionEstado: string;
	public colorEstado: string;

	/// propiedad utilizada para cambio de estado de cartera, toda vez que este maneja cuotas
	cuota?:number;
}